export const ALL_FILIALES_ID = 'all';

export const COUNTRY_FLAGS = {
  'Benin': '/flags/Benin.png',
  "Cote d'Ivoire": '/flags/ci.jpg',
  'Cameroun': '/flags/cameroun.jpg',
  'Congo': '/flags/congo.png',
  'Guinee': '/flags/guinea.jpg',
  'Guinee-Bissau': '/flags/guineabiss.png',
  'Senegal': '/flags/us.png', // À remplacer par le bon fichier
  'Mali': '/flags/us.png', // À remplacer par le bon fichier
  'Burkina Faso': '/flags/us.png', // À remplacer par le bon fichier
  'Niger': '/flags/us.png', // À remplacer par le bon fichier
  'Togo': '/flags/us.png', // À remplacer par le bon fichier
  'Centrafrique': '/flags/us.png', // À remplacer par le bon fichier
  'Tchad': '/flags/us.png', // À remplacer par le bon fichier
  'Gabon': '/flags/us.png', // À remplacer par le bon fichier
  'RD Congo': '/flags/us.png', // À remplacer par le bon fichier
  'Angola': '/flags/us.png', // À remplacer par le bon fichier
  'Mauritanie': '/flags/us.png', // À remplacer par le bon fichier
  'Liberia': '/flags/us.png', // À remplacer par le bon fichier
  'Sierra Leone': '/flags/us.png', // À remplacer par le bon fichier
};

export const getFilialeById = (id, filiales = []) => {
  if (id === ALL_FILIALES_ID || id == null) return null;
  return filiales.find((f) => String(f.id) === String(id)) || null;
};

export const getCountryFlag = (pays, filiale) => {
  // Si la filiale a un champ drapeau, l'utiliser
  if (filiale?.drapeau) {
    return filiale.drapeau;
  }
  // Sinon, utiliser le mapping statique (fallback)
  return COUNTRY_FLAGS[pays] || '';
};

export const ROLE_LABELS = {
  super_admin: 'Super administrateur',
  admin_pays: 'Admin filiale',
  manager: 'Manager',
  user: 'Utilisateur',
};

export const canSwitchFiliales = (user) => {
  if (!user) return false;
  const role = (user.libprofil || user.role || '').toLowerCase();
  if (role === 'super_admin' || role === 'admin_pays') return true;
  if (role === 'admin' || role === 'president' || role === 'directeur' || role === 'manager') return true;
  if (role === 'comptable' || role === 'rh' || role === 'wfm' || role === 'audit' || role === 'visiteur' || role === 'communication' || role === 'responsable intérim') return true;
  return Array.isArray(user.filiales) && user.filiales.length > 1;
};

export const getAssignedFiliales = (user, dynamicFiliales = []) => {
  if (!user) return [];
  // Utiliser les filiales dynamiques si disponibles
  const filialesToUse = dynamicFiliales;
  const role = (user.libprofil || user.role || '').toLowerCase();

  if (role === 'super_admin' || role === 'admin_pays' || role === 'admin' || role === 'president' || role === 'directeur' || role === 'manager' || role === 'comptable' || role === 'rh' || role === 'wfm' || role === 'audit' || role === 'visiteur' || role === 'communication' || role === 'responsable intérim') return filialesToUse;
  if (Array.isArray(user.filiales) && user.filiales.length > 0) {
    return user.filiales;
  }
  const single =
    user.filiale ||
    getFilialeById(user.filiale_id, filialesToUse) ||
    (user.pays ? { id: user.pays_id || user.pays.id, code: user.pays.code, libelle: user.pays.nom || user.pays.libelle, pays: user.pays.nom } : null);
  return single ? [single] : [];
};

export const getDefaultFilialeId = (user) => {
  if (!user) return null;
  const role = (user.libprofil || user.role || '').toLowerCase();
  if (role === 'super_admin' || role === 'admin_pays' || role === 'president' || role === 'directeur' || role === 'comptable' || role === 'rh' || role === 'wfm' || role === 'audit' || role === 'visiteur' || role === 'communication' || role === 'responsable intérim') return ALL_FILIALES_ID;
  const assigned = getAssignedFiliales(user);
  if (assigned.length === 1) return String(assigned[0].id);
  if (assigned.length > 1) return String(assigned[0].id);
  return user.filiale_id != null ? String(user.filiale_id) : null;
};

export const isFilialeAllowed = (user, filialeId, dynamicFiliales = []) => {
  if (!user) return false;
  const role = (user.libprofil || user.role || '').toLowerCase();
  // Ces rôles peuvent voir toutes les filiales y compris la vue consolidée
  if (role === 'super_admin' || role === 'admin' || role === 'president' || role === 'directeur' || role === 'manager' || role === 'comptable' || role === 'rh' || role === 'wfm' || role === 'audit' || role === 'visiteur' || role === 'communication' || role === 'responsable intérim') return true;
  if (filialeId === ALL_FILIALES_ID) return false; // Seuls les rôles ci-dessus peuvent voir la vue consolidée
  const assigned = getAssignedFiliales(user, dynamicFiliales);
  return assigned.some((f) => String(f.id) === String(filialeId));
};
